import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import ParentModal from '../genericComponents/ParentModal'
import Lottie from 'lottie-react'
import JobSuccessTickMark from '../animationsJSON.js/JobSuccessTickMark.json'
import JobFailedMark from '../animationsJSON.js/JobFailedMark.json'
import GenericConfirmationModal from '../genericComponents/GenericConfiramationModal'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { getMenuMode } from '../helper/helperTableFunctions'
import GenericCustomButton from '../genericComponents/GenericCustomButton'
import CopyContentGenericComponent from '../genericComponents/CopyContentGenericComponent'

const getAnimation = (type) => ({
    loop: true,
    autoplay: true,
    animationData: type === 'success' ? JobSuccessTickMark : JobFailedMark,
    rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
    },
    style: {
        width: 110,
        height: 80
    }
})

const WarehouseJobStatusComponent = () => {
    const history = useHistory()
    const seasonPlanningStore = useSelector(state => state.seasonPlanningStore)

    const [selectedModal, setSelectedModal] = useState('')
    const [jobStatus, setJobStatus] = useState('')
    const [jobData, setJobData] = useState({})
    const [jobAllData, setJobAllData] = useState({})

    useEffect(() => {
        return () => {
            clearAllIntervals();
        };
    }, []);

    useEffect(() => {
        if (jobStatus?.toLowerCase() == 'succeeded' || jobStatus?.toLowerCase() == 'failed') {
            clearAllIntervals();
            setSelectedModal(jobStatus?.toLowerCase() == 'succeeded' ? 'jobSuccessModal' : 'jobFailedModal');
        }
    }, [jobStatus]);

    // Function to clear all intervals applied to the window object
    const clearAllIntervals = () => {
        let jobRunInterval = localStorage.getItem("jobRunInterval");
        window.clearInterval(jobRunInterval);
        localStorage.removeItem("jobRunInterval")
    };

    // handle the suceesss for job run
    useEffect(() => {
        if (seasonPlanningStore?.jobRunDetailNewData?.isSuccess) {
            let data = seasonPlanningStore?.["jobRunDetailNewData"]?.data;
            if (data?.resource) {
                setJobData(data?.resource)
                if (data?.resource?.runningjob?.length !== 0) {
                    setJobStatus(data?.resource?.["runningjob"]?.[0]?.status || '');
                    return;
                }
                else if (data?.resource?.runningjob?.length === 0) {
                    setJobStatus(data?.resource?.lastEngineRun || '');
                    return
                }
            }
        }
    }, [seasonPlanningStore?.["jobRunDetailNewData"]?.isSuccess])

    useEffect(() => {
        if (seasonPlanningStore?.createRunOnDemandJobData?.isSuccess) {
            let data = seasonPlanningStore?.["createRunOnDemandJobData"]?.data;
            if (data?.resource) {
                setJobAllData(data?.resource)
            }
        }
    }, [seasonPlanningStore?.["createRunOnDemandJobData"]?.isSuccess])

    // logic to handle the error of the job run api
    useEffect(() => {
        if (seasonPlanningStore?.jobRunDetailNewData?.isError) {
            setJobStatus('')
            setSelectedModal('jobFailedModal')
            clearAllIntervals();
        }
    }, [seasonPlanningStore?.["jobRunDetailNewData"]?.isError])

    // logic to open the success modal if job run succeeds
    useEffect(() => {
        if (jobStatus?.toLowerCase() === 'succeeded') {
            clearAllIntervals();
            setSelectedModal('jobSuccessModal')
        }
        if (jobStatus?.toLowerCase() === 'failed') {
            clearAllIntervals();
            setSelectedModal('jobFailedModal')
        }
    }, [jobStatus])

    console.log("job data", jobData)

    // handle change function
    const handleChange = (type, data) => {
        switch (type) {
            case "viewSummary": {
                setSelectedModal('')
                history.push({
                    pathname:  getMenuMode?.() == "new" ? '/app/product/allokator/replenishment' :  '/inventoryPlanning/summary',
                    states: {
                        id: jobData?.jobId || "",
                        manageid: jobData?.manageRuleId || "",
                        name: jobData?.jobName || "",
                        jobData: {
                            manageRuleId: jobData?.manageRuleId || "",
                            activeJobName: jobData?.jobName || "",
                            jobId: jobData?.jobId || "",
                            setActiveJobDetails: false
                        }
                    }
                });
                break;
            }
            case 'createNewJob':
                if((getMenuMode?.() == 'new' && history?.location?.pathname == "/app/product/allokator/run/replenishment") || (getMenuMode?.() !== "new" && history?.location?.pathname == "/inventoryPlanning/whNew")) {
                    window.location.reload()
                }
                else {
                    setSelectedModal('')
                    history.push({
                        pathname: getMenuMode?.() == "new" ? '/app/product/allokator/run/replenishment' : '/inventoryPlanning/whNew'
                    });
                }
                break;
            default:
                break;
        }
    }

    const getConfirmationModal = () => {
            return <div className='px-12 py-8 flex flex-col items-center gap-2 text-fontBlack text-center'>
                <Lottie
                    {...getAnimation(jobStatus?.toLowerCase() === 'succeeded' ? 'success' : 'failed')}
                />
                <h1 className='text-xl font-semibold mt-[1rem]'>{jobStatus?.toLowerCase() === 'succeeded' ? 'Last Job Run Successful' : 'Last Job Run Failed'}</h1>
                {jobStatus?.toLowerCase() === 'succeeded' ? <div
                    style={{
                        boxShadow: '0px 0px 4px 0px #0000000F'
                    }}
                    className='border border-[#EEEEEE] rounded-[5px] text-center w-full'
                >
                    <div className='py-2 px-3 border-b border-borderSlateGrey flex items-center justify-center gap-1.5'><span className='text-xs font-medium text-[#6A6C70]'>Job ID : </span> <span className='text-[11px] font-semibold text-fontBlack'>{jobData?.jobId}</span> <CopyContentGenericComponent type={2} content={jobData?.jobId} /></div>
                    <div className='py-2.5 px-3 bg-[#F8F8F8]'>
                        <p className='mb-1.5 text-[11px] font-semibold text-fontBlack'>Job Name : {jobData?.jobName}</p>
                        <p className='mb-0 text-[11px] font-semibold text-fontBlack'>Trigger Name : {jobData?.triggerName}</p>
                    </div>
                </div> : <p className='text-xs text-fontGrey'>Click on the view summary to view report</p>}
                <div className={`w-full flex items-center gap-3 ${jobStatus?.toLowerCase() === 'succeeded' ? 'mt-[24px]' : 'mt-[32px]'}`}>
                    <GenericCustomButton
                        label={"View Summary"}
                        type='default'
                        className={'w-1/2'}
                        onClick={() => handleChange("viewSummary")}
                    />
                    <GenericCustomButton
                        type='primary'
                        label={"Create New Job"}
                        className={`w-1/2`}
                        onClick={() => handleChange("createNewJob")}
                    />
                </div>
            </div>
        }

    const getParentChildProps = () => {
        let payload = {
            closeModal: () => { setSelectedModal(false); setJobStatus('') },
            animationType: "bottom"
        }
        switch (selectedModal) {
            case "jobSuccessModal" :
            case 'jobFailedModal': {
                return {
                    ...payload,
                    parentModalOuterMostClassName: 'flex items-center justify-center',
                    postitionProps: { position: 'relative' },
                    dimensions: { width: "60vw", height: "fit-content", maxWidth: '528px', borderRadius: 5 }
                }
            }

            default: {
                break;
            }
        }
    }

    const getChildComponent = () => {
        switch (selectedModal) {
            case "jobSuccessModal":
            case "jobFailedModal": 
                return getConfirmationModal;
            default: break
        }
    }

    return (
        <React.Fragment>
            {selectedModal ? <ParentModal
                getParentChildProps={getParentChildProps()}
                childComponent={getChildComponent()}
                closeModal={() => { setSelectedModal(false) }}
            /> : null}
        </React.Fragment>)
}

export default WarehouseJobStatusComponent